import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '成全影视真的完全免费吗？需要注册会员吗？',
    answer: '是的，成全影视所有内容完全免费在线观看，无需注册会员，无需充值VIP。我们致力于为用户提供真正免费的高清影视体验，没有任何隐藏收费。',
  },
  {
    question: '成全影视支持哪些设备观看？',
    answer: '成全影视支持电脑、平板、手机等多种设备在线观看。您只需使用浏览器访问我们的网站，无需下载任何App或插件，随时随地享受流畅追剧体验。',
  },
  {
    question: '成全影视的视频画质如何？支持投屏吗？',
    answer: '我们提供高清画质（最高支持4K）的影视资源。同时支持Chromecast、AirPlay等主流投屏方式，让您可以将内容投射到电视大屏上观看，享受更好的观影体验。',
  },
  {
    question: '成全影视的影视资源更新速度快吗？',
    answer: '我们的内容团队会第一时间更新最新的电影、电视剧、动漫和综艺资源。热门剧集通常在播出后24小时内同步更新，让您不再错过任何精彩内容。',
  },
  {
    question: '如果在观看过程中遇到卡顿或无法播放怎么办？',
    answer: '如遇播放问题，建议您尝试以下方法：1) 切换播放线路（点击播放器右下角的线路切换按钮）；2) 检查网络连接状态；3) 刷新页面重新加载。如问题持续，可联系我们的客服获取帮助。',
  },
  {
    question: '成全影视有手机App吗？',
    answer: '目前成全影视主要通过网页端提供服务。您可以通过手机浏览器访问我们的网站，同样可以获得流畅的观影体验。我们将网页端体验优化至接近原生App的流畅度。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于成全影视，您想了解的都在这</p>
          </div>

          <div className="space-y-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-lg overflow-hidden transition-all"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <i
                      className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-60 pb-4 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}